import { buildPreAuthLangHeader, initPreAuthPageI18n } from '@/js/sageflo/pre-auth-i18n'

var showEmail = true;
var previousLogins = 0;
var hasError = false;
var loginI18n = null;
var queryParams = {
  route: '',
  params: {}
};

var hash = window.location.hash;
var locationPath = null;

/* SETUP AND EVENT BINDING FUNCTIONS */
$(async function() {
  loginI18n = await initPreAuthPageI18n();
  loginI18n.applyTranslations();
  applyLocalizedLinks();
  applyFooterCopy();

  

  $('#btnAuthEmail').click(function() {
    if (showEmail) {
      authEmail();
    } else {
      submitPassword();
    }
    return false;
  });
  $('#btnLogin').click(function() {
    submitPassword();
    return false;
  });

  $('#loginEmail').on('keydown', function(event) {
    if (event.key !== 'Enter') {
      return;
    }

    event.preventDefault();
    if (showEmail) {
      authEmail();
    } else {
      submitPassword();
    }
    return false;
  });

  $('#pwd').on('keydown', function(event) {
    if (event.key !== 'Enter') {
      return;
    }

    event.preventDefault();
    if (showEmail) {
      authEmail();
    } else {
      submitPassword();
    }
    return false;
  });

  $('[data-dismiss="modal"]').click(function() {
    closeModal();
    return false;
  });  

  $('[data-trouble-help]').click(function() {
    showTroubleHelp(event)
    return false;
  });

  $('[data-stop-prop]').click(function() {
    return false
  });

  $('#loginEmail').on('blur', function() {
    if (
      $(this)
        .hasClass('is-invalid')
    ) {
      validateInput($('#loginEmail'), t('preAuth.login.emailRequired'), t('preAuth.login.emailPlaceholder'));
    }
  });

  $('#loginEmail').on('change', function() {
    try {
      let val = $(this).val()

      if (val != val.trim()) {
        $(this).val(val.trim())
      }      
    } catch(e) {}
  });

  $('#pwd').on('blur', function() {
    if (
      $(this)
        .hasClass('is-invalid')
    ) {
      validateInput($('#pwd'), t('preAuth.login.passwordRequired'), t('preAuth.login.passwordPlaceholder'));
    }
  });

  $('#changeEmailLink').click(showEmailPanel);
  var route = urlParam('route');
  queryParams.route = route ? route : '';
  var errMsg = urlParam('msg');


  if (errMsg) {
    $('#message').removeClass('d-none');
    $('#message span').html( errMsg );
    hasError = true;
  }

  let id = urlParam('id');
  if (id){
    queryParams.params.id = id;
  }

  let lang = urlParam('lang');
  if (lang) {
    queryParams.params.lang = lang;
  }

  if (urlParam('searchEmail'))
    queryParams.params['searchEmail'] = urlParam('searchEmail');

  //console.log(queryParams);
  locationPath = getLocationPath();

  /*$(window).on('load',function() {
    $(document).tooltip({
      selector: '[data-toggle="tooltip"]',
      container : 'body',
      trigger: 'hover',
      html: true,
      placement: 'top',
      delay: {show: 1250, hide: 100}
    })
  });*/

});

function urlParam(name){
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  if (results==null){
     return null;
  }
  else{
     return decodeURIComponent(results[1]) || 0;
  }
}

function getLocationPath(){
  if (hash){
    return '/' + hash;
  } else {
    var params = '';
    for (const key in queryParams.params) {
      params += '&' + key + '=' + queryParams.params[key];
    }
    if (params.length > 0) {
      params = '?' + params.substring(1);
    }
    return '/' + queryParams.route + params;
  }
}

function authEmail() {
  try {
    sessionStorage.clear(); //clear any previous session data. 
  } catch(e) {console.error(e)}
  
  hideErrorMessage();
  var loginName = $('#loginEmail').val();
  if (validateInput($('#loginEmail'), t('preAuth.login.emailRequired'), t('preAuth.login.emailPlaceholder'))) {
    var payload = {
      email: $('#loginEmail').val(),
      location: locationPath,
    }
    // add ajax validation code here, if successful, return true/redirect to main page
    $.ajax({
      type: 'POST',
      url: '/api/v1/auth-email',
      data: payload,
      headers: getRequestHeaders(),
      success: function(response) {
        if (response.next == 'password') {
          $('#emailField').val($('#loginEmail').val());
          $('#pwd').val('');
          $('#emailDisplay').text($('#loginEmail').val());
          showPasswordPanel();
        } else if (response.next == 'redirect') {
          //window.location.href = '/' + queryParams.route + params;
          //console.log(response.location);
          window.location.href = response.location;
        }
      },
      error: function(xhr, textStatus, errorThrown) {
        if (xhr.status == 503 && xhr.responseJSON && xhr.responseJSON.maintenance){
          window.location = "/maintenance?end=" + xhr.responseJSON.expected_end_time
        } else if (xhr.status == 401) {
          console.log('reponse text: ' + xhr.responseText);
          var errorMessage = t('preAuth.login.unknownUser');
          showErrorMessage(errorMessage);
        } else {
          console.log(errorThrown);
          console.log(xhr);
          console.log(textStatus);
          if (!textStatus || textStatus.toLowerCase()=='error') {
            if (xhr.responseJSON && xhr.responseJSON.message) {
              textStatus = xhr.responseJSON.message;
            } else if (errorThrown) {
              textStatus = errorThrown;
            } else {
              textStatus = xhr.responseText;
            }
          }
          showErrorMessage(textStatus);
          //showErrorMessage(textStatus);
        }
      }
      //,statusCode: {
      //401: function() {
      //}}
    });
  }
}

function showPasswordPanel() {
  showEmail = false;
  $('#emailPanel')
    .addClass('d-none')
    .removeClass('d-block');
  $('#passwordPanel')
    .addClass('d-block')
    .removeClass('d-none');
  $('#pwd').val('');
  $('#pwd').focus();
}

function showEmailPanel() {
  showEmail = true;
  $('#passwordPanel')
    .addClass('d-none')
    .removeClass('d-block');
  $('#emailPanel')
    .addClass('d-block')
    .removeClass('d-none');
  $('#loginEmail').focus();
}

function submitPassword() {
  hideErrorMessage();
  if (validateInput($('#pwd'), t('preAuth.login.passwordRequired'), t('preAuth.login.passwordPlaceholder'))) {
    // add ajax validation code here, if successful, return true/redirect to main page
    $.ajax({
      type: 'POST',
      url: '/api/v1/login',
      data: $('#frmEmail').serialize(),
      headers: getRequestHeaders(),
      success: function(data) {
        var params = '';
        for (const key in queryParams.params) {
          params += '&' + key + '=' + queryParams.params[key];
        }
        if (params.length > 0) {
          params = '?' + params.substring(1);
        }
        window.location.href = '/' + queryParams.route + params;
      },
      error: function(xhr, textStatus, errorThrown) {
        if (xhr.status == 401) {
          console.log('reponse text: ' + xhr.responseText);
          var errorMessage = null;
          if (xhr.responseJSON.reason) {
            if (
              xhr.responseJSON.reason == 'INVALID_USERNAME_PASSWORD' &&
              (xhr.responseJSON.remain > 2 || !xhr.responseJSON.remain)
            ) {
              errorMessage = t('preAuth.login.invalidPassword');
            } else {
              errorMessage = xhr.responseJSON.message;
            }
          } else {
            errorMessage = t('preAuth.login.invalidPassword');
          }
          showErrorMessage(errorMessage);
        } else {
          if (!textStatus || textStatus.toLowerCase()=='error') {
            if (xhr.responseJSON && xhr.responseJSON.message) {
              textStatus = xhr.responseJSON.message;
            } else if (errorThrown) {
              textStatus = errorThrown;
            } else {
              textStatus = xhr.responseText;
            }
          }
          showErrorMessage(textStatus);
        }
      }
      //,statusCode: {
      //401: function() {
      //}}
    });
  }
}

function showErrorMessage(message) {
  hasError = true;
  $('[data-login-error]').html(message);
  $('#message')
    .addClass('d-block')
    .removeClass('d-none');
}

function hideErrorMessage() {
  hasError = false;
  $('#message')
    .addClass('d-none')
    .removeClass('d-block');
}

function showTroubleHelp(e) {
  e.preventDefault()
  showModal()
}

function showModal() {
  let modal = document.getElementById('modalHelp')

  $('#modalbackdrop')
    .removeClass('d-none')

  $('#modalHelp')
    .addClass('show')

  $('#modalbackdrop')
    .addClass('show')

  modal.style.display = "block"
}

function closeModal() {
  let modal = document.getElementById('modalHelp')
  modal.style.display = "none"
  $('#modalbackdrop')
    .addClass('d-none')

  $('#modalHelp')
    .removeClass('show')

  $('#modalbackdrop')
    .removeClass('show')

}

function validateInput(input, errPlaceholder, successPlaceholder) {
  const val = $(input).val();

  if (val !== null && val.trim() !== '') {
    $(input).removeClass('is-invalid');
    //$(input).attr('placeholder', successPlaceholder);
    return true;
  } else {
    $(input).addClass('is-invalid');
    //$(input).attr('placeholder', errPlaceholder);
    //$('#'+input).focus();
    return false;
  }
}

function t(key, vars) {
  if (!loginI18n) {
    return key;
  }

  return loginI18n.t(key, vars);
}

function applyLocalizedLinks() {
  if (!loginI18n) {
    return;
  }

  $('[data-forgot-password-link]').each(function() {
    $(this).attr('href', loginI18n.buildLocalizedPath('/forgot'));
  });
}

function applyFooterCopy() {
  const year = new Date().getFullYear();

  $('[data-footer-copyright]').each(function() {
    $(this).text(t('preAuth.common.copyright', { year: year }));
  });
}

function getRequestHeaders() {
  if (!loginI18n) {
    return {}
  }

  return buildPreAuthLangHeader(loginI18n.locale)
}
